import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { BlueSwipeAccountFormSchema } from './validation';

const defaultInitialValues = {
  bnk_accountNumber: '',
  bnk_routingNumber: ''
}

class BankAccountForm_BlueSwipe extends Component {
  constructor(props) {
    super(props);

    this.state = { type: 'individual', errors: null, isSubmitting: false }
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.errorMessage !== this.props.errorMessage && this.state.isSubmitting) {
      this.setState({ isSubmitting: false });
    }
  }

  onSubmit(values, form) {
    let { onSubmit } = this.props;
    this.setState({ isSubmitting: true });
    values.type = this.state.type;
    onSubmit(values, form);
  }

  render() {
    let { onBack, errorMessage, initialValues, isModal } = this.props;
    return (
      <Formik
        validationSchema={BlueSwipeAccountFormSchema}
        initialValues={initialValues ? initialValues : defaultInitialValues}
        onSubmit={this.onSubmit}>
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <div>
              <p>Your bank account info is required to accept payment and is securely encrypted and stored by our Payment Processor.</p>
              <div>
                <div className="fieldgroup row fieldgroup-required">
                  <Field
                    name="bnk_accountNumber"
                    type="number"
                    placeholder="Bank Account Number"
                    className={(errors.bnk_accountNumber && touched.bnk_accountNumber) ? "form-control error-input" : "form-control"}
                  />
                  <ErrorMessage name="bnk_accountNumber" component="div" className="error-message" />
                </div>
                <div className="fieldgroup row fieldgroup-required">
                  <Field
                    name="bnk_routingNumber"
                    type="number"
                    placeholder="Bank Routing Number"
                    className={(errors.bnk_routingNumber && touched.bnk_routingNumber) ? "form-control error-input" : "form-control"}
                  />
                  <ErrorMessage name="bnk_routingNumber" component="div" className="error-message" />
                </div>
              </div>
              <div>
                {errorMessage && (<div className="error-message mb-3">{errorMessage.message}</div>)}
                <div className={`button-row row ${isModal ? 'modal-footer pb-0' : ''}`}>
                  <div className="col">
                    <label onClick={onBack}>
                      Cancel
                    </label>
                  </div>
                  <div className="col text-right">
                    <button className="btn btn-primary" disabled={isSubmitting} type="submit">{isSubmitting ? 'Verifying...' : 'Submit'}</button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default BankAccountForm_BlueSwipe;
